export default __webpack_public_path__ + "static/media/intro.f6ba04b0.svg";